
const Heading3 = ({children}) => {
    return(
        <h3 className={"anton-900 bg-dark py-1 px-3 text-white mb-3 border-radius-5"}>{children}</h3>
    )
}

export default Heading3;